<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="EPIGRAPH">Marino <em class="italic">saw </em>the rose, as Adam had seen it in Paradise, and he realized that it lay within its own eternity, not within his words, and that we might speak about the rose, allude to it, but never truly express it, and that the tall, haughty volumes that made a golden dimness in the corner of his room were not (as his vanity had dreamed them) a mirror of the world, but just another thing added to the world’s contents.</p>
<p class="EPICREDIT _idGenParaOverride-1">Jorge Luis Borges, “The Yellow Rose”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Williams_The_Election_of_Grace_text_CC.vue?585c1ae6